import React, {Component} from "react";
import _ from "lodash";
import CdmLayout from "../../../templates/cdm";
import {NavLink} from "react-router-dom";
import ProgressBar from "../../elements/widgets/progress-bar";
import current_tasks from "../../json/current_tasks";
import polygonList from "../../json/polygons";
import AreaMap from "../../elements/maps/area-maps";
import ZoneItem from "../../elements/maps/zone-item";

class CdmZonesDirectory extends Component {
	render() {
		let activity = _.find(current_tasks.data, {id: _.toInteger(this.props.match.params.id)});
		let step = _.find(activity.tasks, {id: _.toInteger(this.props.match.params.step)});
		return (<div className="columns is-multiline">
			<div className="column is-10 is-offset-1">
				<div className="column is-12">
					<div className="level">
						<NavLink to={`/cdm/tarea/${activity.id}`} className="button is-cdm-blue is-small"><i className="fa fa-arrow-left" style={{marginRight: '10px'}} /> Volver a la tarea</NavLink>
					</div>
				</div>
				<div className="column is-12">
					<div className="level cdm-header--dates">
						<div className="level-left">
							<div className="level-item">
								<p className="due-date">
									<span>Fecha límite</span>
									{step.date_finish}
								</p>
							</div>
						</div>
						<div className="level-right">
							<div className="level-item progress-detail">
								<ProgressBar total={100} detect={100} />
							</div>
						</div>
					</div>
					<div className={`cdm-header ${activity.category.style}`}>
						<div className="cdm-header--details">
							<p className="category">{activity.category.name}</p>
							<p>{step.duration} días</p>
						</div>
						<div className="cdm-header--title">
							<h1>{`${step.step}. ${step.title}`}</h1>
							<div className="modified">
								<p>
									<span>Última modificación</span>
									2018-08-16
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-12 map-container">
					<AreaMap coords={this.state.polygons.detail.coordinates} color={this.state.polygons.detail.color} />
				</div>
				<div className="column is-12">
					<div className="field">
						<div className="control">
							<label htmlFor="finished" className="checkbox">
								<input type="checkbox" className="checkbox" id="finished" value="1" checked={ step.finished ? 'checked' : false} onChange={() => true} />
								He concluido esta tarea
							</label>
						</div>
					</div>
				</div>
				<hr/>
				<div className="column is-12">
					<div className="cdm-map-zones">
						{_.map(this.state.polygons.list, (poly, p) => {
							return <ZoneItem {...poly} selected={poly.id === this.state.polygons.detail.id && true} key={`zone-item-${p}`} setCoords={this.setCoords} />
						})}
					</div>
				</div>
			</div>
		</div>)
	}

	constructor() {
		super();
		this.state = {
			polygons: {
				list: [...polygonList.data],
				detail: {
					id: 0,
					color: undefined,
					coordinates: undefined,
				}
			}
		}
		this.setCoords = this.setCoords.bind(this);
	}

	setCoords(poly) {
		return this.setState({
			polygons: {
				...this.state.polygons,
				detail: poly.props
			}
		});
	}
}

export default CdmLayout(CdmZonesDirectory, {
	title: 'Directorio de zonas identificadas',
	subnav: {
		icon: 'fa-map',
		name: 'Mapa',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/substantial/directory-zones.jsx